import { render, staticRenderFns } from "./CustomTabNav.vue?vue&type=template&id=f12f76fa&scoped=true&"
import script from "./CustomTabNav.vue?vue&type=script&lang=js&"
export * from "./CustomTabNav.vue?vue&type=script&lang=js&"
import style0 from "./CustomTabNav.vue?vue&type=style&index=0&id=f12f76fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f12f76fa",
  null
  
)

export default component.exports